<div class="action-wrapper" (click)="$event.stopPropagation()">
  <button
    type="button"
    class="action-trigger"
    [ngbPopover]="actionMenu"
    #actionPopover="ngbPopover"
    triggers="manual"
    [autoClose]="'outside'"
    container="body"
    [placement]="currentPlacement"
    popoverClass="contractors-action-popover"
    (click)="togglePopover(actionPopover, $event)"
    (shown)="onPopoverShown()"
    (hidden)="onPopoverHidden()"
  >
    Action
  </button>

  <ng-template #actionMenu>
    <!-- Added by Amisha on 07/16/2026 so each tab shows only the actions it passes into the shared action component. -->
    <div class="contractors-action-menu-card">
      <button
        *ngIf="viewDetails"
        type="button"
        class="contractors-action-item"
        (click)="onViewDetails()"
      >
        <span class="contractors-action-item-label">View Details</span>
      </button>
      <button
        *ngIf="viewApplication"
        type="button"
        class="contractors-action-item"
        (click)="onViewApplication()"
      >
        <span class="contractors-action-item-label">View Application</span>
      </button>
      <button
        *ngIf="renew"
        type="button"
        class="contractors-action-item"
        (click)="onRenew()"
        [disabled]="canRenew && !canRenew(row)"
      >
        <span class="contractors-action-item-label">Renew</span>
      </button>
      <button
        *ngIf="delete"
        type="button"
        class="contractors-action-item"
        (click)="onDelete()"
        [disabled]="canDelete && !canDelete(row)"
      >
        <span class="contractors-action-item-label">Delete</span>
      </button>
      <button
        *ngIf="disable"
        type="button"
        class="contractors-action-item"
        (click)="onDisable()"
        [disabled]="canDisable && !canDisable(row)"
      >
        <span class="contractors-action-item-label">Disable</span>
      </button>
      <button
        *ngIf="enable"
        type="button"
        class="contractors-action-item"
        (click)="onEnable()"
        [disabled]="canEnable && !canEnable(row)"
      >
        <span class="contractors-action-item-label">Enable</span>
      </button>
      <button
        *ngIf="viewProfile"
        type="button"
        class="contractors-action-item"
        (click)="onViewProfile()"
      >
        <span class="contractors-action-item-label">View Profile</span>
      </button>
    </div>
  </ng-template>
</div>
